// Extensions the document and media editors' inline rename keeps out of the
// editable text, so users don't change or delete them by accident. Also where a
// name is split to judge it blank (see isBlankFilename).
const HIDDEN_EDIT_EXTENSIONS = ['.pdf', '.mp4', '.mp3', '.jpeg', '.jpg'];

export const splitHiddenExtension = (name: string): [string, string] => {
  const lower = name.toLowerCase();
  const ext = HIDDEN_EDIT_EXTENSIONS.find((e) => lower.endsWith(e));
  return ext
    ? [name.slice(0, -ext.length), name.slice(-ext.length)]
    : [name, ''];
};

/**
 * BLANK when nothing but spaces is left in front of the extension (VE-32151).
 * The server trims leading whitespace, so "   .pdf" would be stored as ".pdf".
 */
export const isBlankFilename = (name: string): boolean =>
  !splitHiddenExtension(name)[0].trim();

/**
 * The name a draft would save as: the field's text plus the extension hidden
 * from it, unless the user typed that extension themselves.
 */
export const resolveDraftFilename = (
  draftName: string,
  hiddenExt: string
): { name: string; isBlank: boolean } => {
  const userTypedExt =
    !!hiddenExt && draftName.toLowerCase().endsWith(hiddenExt.toLowerCase());
  const name = userTypedExt ? draftName : draftName + hiddenExt;
  return { name, isBlank: isBlankFilename(name) };
};
